<template>
  <Head>
    <Title>Valentine - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Valentine</h1>
      <div class="mb-5">
        <br>
        Vím, jak náročný může být každodenní život s dětmi. Často zapomínáme na to, jak důležité je najít si čas jen jeden pro druhého.
        <br><br>
        Můj nový projekt „Valentine“ – umělecké focení pro páry – je příležitost zastavit se,
        prožít společné chvíle a připomenout si, jak moc jste si navzájem důležití. Zachytím vaše skutečné emoce
        a vytvořím pro vás nejen vzpomínky, ale i malá umělecká díla, která vás vždy zahřejí u srdce.
        <br><br>
        Chcete někomu udělat radost? Toto focení si můžete koupit jako dárek. Mám pro vás připravené krásné dárkové poukazy.
        <br><br>
        Rezervace termínu nebo objednávka poukazu v soukromých zprávách.
        <br><br>
      </div>
    </v-sheet>
    <v-row v-for="index in 3">
      <v-col cols="12" md="6">
        <v-img :src="'valentin/' + (index * 2 - 1) + '.jpg'" aspect-ratio="5:4"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'valentin/' + (index * 2) + '.jpg'" aspect-ratio="5:4" v-if="index<3"/>
      </v-col>
    </v-row>
  </v-container>
</template>